import { registerEvents } from "./skyward.ui.events";
import { registerLayoutResizeCallback } from "./skyward.ui.window"

const events =
{
    attachiFrameResizeEvents
};

registerEvents("iframe", events);

function attachiFrameResizeEvents(this: HTMLIFrameElement | JQuery<HTMLIFrameElement>)
{
    const iframeElement = $(this);
    const iframe = iframeElement[0] as HTMLIFrameElement;
    async function setHeight()
    {
        if (iframe && iframe.contentDocument && iframe.contentDocument.body && iframe.contentDocument.body.scrollHeight)
        {
            iframe.style.height = iframe.contentDocument.body.scrollHeight + 50 + 'px';
        }
    }

    registerLayoutResizeCallback(setHeight);
    iframeElement.on("load" as any, setHeight);
    setHeight(); //calling in the case that the iframe has already loaded
}